import { render } from "./UserTextResponse.vue?vue&type=template&id=7ec957ec&scoped=true"
import script from "./UserTextResponse.js?vue&type=script&lang=js&external"
export * from "./UserTextResponse.js?vue&type=script&lang=js&external"

import "./UserTextResponse.vue?vue&type=style&index=0&id=7ec957ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec957ec"],['__file',"src/components/ChatWidget/UserTextResponse/UserTextResponse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec957ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec957ec', __exports__)) {
    api.reload('7ec957ec', __exports__)
  }
  
  module.hot.accept("./UserTextResponse.vue?vue&type=template&id=7ec957ec&scoped=true", () => {
    api.rerender('7ec957ec', render)
  })

}


export default __exports__